import { Grid } from '@material-ui/core';
import {
  EntityAboutCard,
  EntityLayout,
  EntityLinksCard,
  EntitySwitch
} from '@backstage/plugin-catalog';
import {
  EntityApiDefinitionCard,
  EntityConsumingComponentsCard,
  EntityProvidingComponentsCard
} from '@backstage/plugin-api-docs';
import { EntityCatalogGraphCard } from '@backstage/plugin-catalog-graph';
import { defaultEntityWarningContent } from './EntityWarningContent';
import { hasLinks } from './hasLinks';

export const apiPage = () => (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3}>
        {defaultEntityWarningContent}
        <Grid item md={6}>
          <EntityAboutCard />
        </Grid>
        <Grid item md={6} xs={12}>
          <EntityCatalogGraphCard height={400} />
        </Grid>

        <EntitySwitch>
          <EntitySwitch.Case if={hasLinks}>
            <Grid item xs={12} md={6}>
              <EntityLinksCard />
            </Grid>
          </EntitySwitch.Case>
        </EntitySwitch>

        
        <Grid container item md={12}>
          <Grid item md={6}>
            <EntityProvidingComponentsCard />
          </Grid>
          <Grid item md={6}>
            <EntityConsumingComponentsCard />
          </Grid>
        </Grid>
      </Grid>
    </EntityLayout.Route>

    <EntityLayout.Route path="/definition" title="Definition">
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <EntityApiDefinitionCard />
        </Grid>
      </Grid>
    </EntityLayout.Route>
  </EntityLayout>
);
